import BRIEF_DEFAULTS_BY_EVENT_TYPE from './briefDefaultsByEventType'

const _EVENT_TYPES = [
  'Party',
  'Private Dining',
  'Meeting/Workshop',
  'Team Activity',
  'Presentation',
  'Wedding',
  'Networking',
  'Studio',
  'Conference',
  'Training',
  'Accommodation',
  'Something Else',
] as const

export type EventType = (typeof _EVENT_TYPES)[number]

const isEventType = (eventType?: string | null): eventType is EventType =>
  !!eventType && eventType in BRIEF_DEFAULTS_BY_EVENT_TYPE

export default isEventType
